!function (t, e) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = e(require("react"), require("classnames"));else if ("function" == typeof define && define.amd) define(["react", "classnames"], e);else {
    var r = "object" == typeof exports ? e(require("react"), require("classnames")) : e(t.react, t.classnames);
    for (var n in r) ("object" == typeof exports ? exports : t)[n] = r[n];
  }
}("undefined" != typeof self ? self : this, function (t, e) {
  return function (t) {
    var e = {};
    function r(n) {
      if (e[n]) return e[n].exports;
      var o = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }
    return r.m = t, r.c = e, r.d = function (t, e, n) {
      r.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.t = function (t, e) {
      if (1 & e && (t = r(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) r.d(n, o, function (e) {
        return t[e];
      }.bind(null, o));
      return n;
    }, r.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return r.d(e, "a", e), e;
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, r.p = "", r(r.s = 137);
  }({
    0: function _(e, r) {
      e.exports = t;
    },
    1: function _(t, r) {
      t.exports = e;
    },
    12: function _(t, e, r) {
      "use strict";

      r.d(e, "b", function () {
        return o;
      }), r.d(e, "a", function () {
        return _s;
      });
      "function" == typeof Symbol && Symbol.iterator;
      /*! *****************************************************************************
      Copyright (c) Microsoft Corporation. All rights reserved.
      Licensed under the Apache License, Version 2.0 (the "License"); you may not use
      this file except in compliance with the License. You may obtain a copy of the
      License at http://www.apache.org/licenses/LICENSE-2.0
      
      THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
      KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
      WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
      MERCHANTABLITY OR NON-INFRINGEMENT.
      
      See the Apache Version 2.0 License for specific language governing permissions
      and limitations under the License.
      ***************************************************************************** */
      var _n = function n(t, e) {
        return (_n = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
        })(t, e);
      };
      function o(t, e) {
        function r() {
          this.constructor = t;
        }
        _n(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      }
      var _s = function s() {
        return (_s = Object.assign || function (t) {
          for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
          return t;
        }).apply(this, arguments);
      };
    },
    137: function _(t, e, r) {
      "use strict";

      var _n2,
        o = this && this.__extends || (_n2 = function n(t, e) {
          return (_n2 = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (t, e) {
            t.__proto__ = e;
          } || function (t, e) {
            for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
          })(t, e);
        }, function (t, e) {
          function r() {
            this.constructor = t;
          }
          _n2(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
        }),
        s = this && this.__assign || function () {
          return (s = Object.assign || function (t) {
            for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
            return t;
          }).apply(this, arguments);
        },
        i = this && this.__rest || function (t, e) {
          var r = {};
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
          if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for (n = Object.getOwnPropertySymbols(t); o < n.length; o++) e.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[o]) && (r[n[o]] = t[n[o]]);
          }
          return r;
        },
        a = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var l = a(r(0)),
        c = a(r(1)),
        p = a(r(138));
      e.TopAppBarFixedAdjust = p.default;
      var u = a(r(139));
      e.TopAppBarSection = u.default;
      var d = a(r(140));
      e.TopAppBarRow = d.default;
      var f = a(r(141));
      e.TopAppBarTitle = f.default;
      var _ = a(r(142));
      e.TopAppBarIcon = _.default;
      var h = r(24),
        y = r(143),
        O = r(39),
        g = r(144),
        b = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.topAppBarElement = l.default.createRef(), e.state = {
              classList: new Set(),
              style: {}
            }, e.initializeFoundation = function () {
              var t = e.props,
                r = t.short,
                n = t.shortCollapsed,
                o = t.fixed;
              e.foundation && e.foundation.destroy(), e.foundation = r || n ? new g.MDCShortTopAppBarFoundation(e.adapter) : o ? new y.MDCFixedTopAppBarFoundation(e.adapter) : new O.MDCTopAppBarFoundation(e.adapter), e.foundation.init();
            }, e.getMergedStyles = function () {
              var t = e.state.style;
              return Object.assign({}, t, e.props.style);
            }, e;
          }
          return o(e, t), Object.defineProperty(e.prototype, "classes", {
            get: function get() {
              var t,
                e = this.state.classList,
                r = this.props,
                n = r.className,
                o = r.dense,
                s = r.fixed,
                i = r.prominent,
                a = r.short,
                l = r.shortCollapsed;
              return c.default(h.cssClasses.BASE, Array.from(e), n, ((t = {})[h.cssClasses.FIXED] = s, t[h.cssClasses.SHORT] = l || a, t[h.cssClasses.SHORT_COLLAPSED] = l, t[h.cssClasses.PROMINENT] = i, t[h.cssClasses.DENSE] = o, t));
            },
            enumerable: !0,
            configurable: !0
          }), e.prototype.componentDidMount = function () {
            this.initializeFoundation(), this.props.scrollTarget && this.setState({
              scrollTarget: this.props.scrollTarget
            });
          }, e.prototype.componentWillUnmount = function () {
            this.foundation.destroy();
          }, e.prototype.componentDidUpdate = function (t, e) {
            var r = this;
            ["short", "shortCollapsed", "fixed"].some(function (e) {
              return r.props[e] !== t[e];
            }) && this.setState({
              classList: new Set()
            }, this.initializeFoundation), t.scrollTarget !== this.props.scrollTarget && (this.foundation.destroyScrollHandler(), this.setState({
              scrollTarget: this.props.scrollTarget
            })), e.scrollTarget !== this.state.scrollTarget && this.foundation.initScrollHandler();
          }, Object.defineProperty(e.prototype, "adapter", {
            get: function get() {
              var t = this;
              return {
                addClass: function addClass(e) {
                  return t.setState({
                    classList: t.state.classList.add(e)
                  });
                },
                removeClass: function removeClass(e) {
                  var r = t.state.classList;
                  r.delete(e), t.setState({
                    classList: r
                  });
                },
                hasClass: function hasClass(e) {
                  return t.classes.split(" ").includes(e);
                },
                setStyle: function setStyle(e, r) {
                  var n = Object.assign({}, t.state.style);
                  n[e] = r, t.setState({
                    style: n
                  });
                },
                getTopAppBarHeight: function getTopAppBarHeight() {
                  return t.topAppBarElement && t.topAppBarElement.current ? t.topAppBarElement.current.clientHeight : 0;
                },
                registerScrollHandler: function registerScrollHandler(e) {
                  t.state.scrollTarget && t.state.scrollTarget.current ? t.state.scrollTarget.current.addEventListener("scroll", e) : window.addEventListener("scroll", e);
                },
                deregisterScrollHandler: function deregisterScrollHandler(e) {
                  t.state.scrollTarget && t.state.scrollTarget.current ? t.state.scrollTarget.current.removeEventListener("scroll", e) : window.removeEventListener("scroll", e);
                },
                getViewportScrollY: function getViewportScrollY() {
                  return t.state.scrollTarget && t.state.scrollTarget.current ? t.state.scrollTarget.current.scrollTop : window.pageYOffset;
                },
                getTotalActionItems: function getTotalActionItems() {
                  return t.topAppBarElement && t.topAppBarElement.current ? t.topAppBarElement.current.querySelectorAll("." + h.cssClasses.ACTION_ITEM).length : 0;
                },
                registerResizeHandler: function registerResizeHandler(t) {
                  window.addEventListener("resize", t);
                },
                deregisterResizeHandler: function deregisterResizeHandler(t) {
                  window.removeEventListener("resize", t);
                },
                registerNavigationIconInteractionHandler: function registerNavigationIconInteractionHandler() {
                  return null;
                },
                deregisterNavigationIconInteractionHandler: function deregisterNavigationIconInteractionHandler() {
                  return null;
                },
                notifyNavigationIconClicked: function notifyNavigationIconClicked() {
                  t.props.onNavIconClicked && t.props.onNavIconClicked();
                }
              };
            },
            enumerable: !0,
            configurable: !0
          }), e.prototype.render = function () {
            var t = this.props,
              e = t.children,
              r = (t.className, t.dense, t.fixed, t.short, t.shortCollapsed, t.prominent, t.scrollTarget, t.tag),
              n = i(t, ["children", "className", "dense", "fixed", "short", "shortCollapsed", "prominent", "scrollTarget", "tag"]);
            return l.default.createElement(r, s({}, n, {
              className: this.classes,
              style: this.getMergedStyles(),
              ref: this.topAppBarElement
            }), e);
          }, e.defaultProps = {
            className: "",
            dense: !1,
            fixed: !1,
            prominent: !1,
            short: !1,
            shortCollapsed: !1,
            style: {},
            tag: "header"
          }, e;
        }(l.default.Component);
      e.default = b;
    },
    138: function _(t, e, r) {
      "use strict";

      var n = this && this.__assign || function () {
          return (n = Object.assign || function (t) {
            for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
            return t;
          }).apply(this, arguments);
        },
        o = this && this.__rest || function (t, e) {
          var r = {};
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
          if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for (n = Object.getOwnPropertySymbols(t); o < n.length; o++) e.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[o]) && (r[n[o]] = t[n[o]]);
          }
          return r;
        },
        s = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var i = s(r(0)),
        a = s(r(1));
      e.default = function (t) {
        var e,
          r = t.tag,
          s = void 0 === r ? "main" : r,
          l = t.children,
          c = t.className,
          p = void 0 === c ? "" : c,
          u = t.dense,
          d = void 0 !== u && u,
          f = t.prominent,
          _ = void 0 !== f && f,
          h = t.short,
          y = void 0 !== h && h,
          O = o(t, ["tag", "children", "className", "dense", "prominent", "short"]),
          g = "mdc-top-app-bar",
          b = "-fixed-adjust",
          v = a.default(p, ((e = {})[g + "--short" + b] = y, e[g + "--dense" + b] = d && !_, e[g + "--dense-prominent" + b] = d && _, e[g + "--prominent" + b] = !d && _, e[g + "-" + b] = !y && !d && !_, e));
        return i.default.createElement(s, n({
          className: v
        }, O), l);
      };
    },
    139: function _(t, e, r) {
      "use strict";

      var n = this && this.__assign || function () {
          return (n = Object.assign || function (t) {
            for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
            return t;
          }).apply(this, arguments);
        },
        o = this && this.__rest || function (t, e) {
          var r = {};
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
          if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for (n = Object.getOwnPropertySymbols(t); o < n.length; o++) e.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[o]) && (r[n[o]] = t[n[o]]);
          }
          return r;
        },
        s = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var i = s(r(0)),
        a = s(r(1)),
        l = r(24);
      e.default = function (t) {
        var e,
          r = t.align,
          s = t.className,
          c = t.children,
          p = t.tag,
          u = void 0 === p ? "section" : p,
          d = o(t, ["align", "className", "children", "tag"]);
        return i.default.createElement(u, n({
          className: a.default(s, l.cssClasses.SECTION, (e = {}, e[l.cssClasses.SECTION_START] = "start" === r, e[l.cssClasses.SECTION_END] = "end" === r, e))
        }, d), c);
      };
    },
    140: function _(t, e, r) {
      "use strict";

      var n = this && this.__assign || function () {
          return (n = Object.assign || function (t) {
            for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
            return t;
          }).apply(this, arguments);
        },
        o = this && this.__rest || function (t, e) {
          var r = {};
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
          if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for (n = Object.getOwnPropertySymbols(t); o < n.length; o++) e.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[o]) && (r[n[o]] = t[n[o]]);
          }
          return r;
        },
        s = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var i = s(r(0)),
        a = s(r(1)),
        l = r(24);
      e.default = function (t) {
        var e = t.children,
          r = t.className,
          s = t.tag,
          c = void 0 === s ? "div" : s,
          p = o(t, ["children", "className", "tag"]);
        return i.default.createElement(c, n({
          className: a.default(r, l.cssClasses.ROW)
        }, p), e);
      };
    },
    141: function _(t, e, r) {
      "use strict";

      var n = this && this.__assign || function () {
          return (n = Object.assign || function (t) {
            for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
            return t;
          }).apply(this, arguments);
        },
        o = this && this.__rest || function (t, e) {
          var r = {};
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
          if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for (n = Object.getOwnPropertySymbols(t); o < n.length; o++) e.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[o]) && (r[n[o]] = t[n[o]]);
          }
          return r;
        },
        s = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var i = s(r(0)),
        a = s(r(1)),
        l = r(24);
      e.default = function (t) {
        var e = t.children,
          r = t.className,
          s = t.tag,
          c = void 0 === s ? "span" : s,
          p = o(t, ["children", "className", "tag"]);
        return i.default.createElement(c, n({
          className: a.default(r, l.cssClasses.TITLE)
        }, p), e);
      };
    },
    142: function _(t, e, r) {
      "use strict";

      var n = this && this.__assign || function () {
          return (n = Object.assign || function (t) {
            for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
            return t;
          }).apply(this, arguments);
        },
        o = this && this.__rest || function (t, e) {
          var r = {};
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
          if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for (n = Object.getOwnPropertySymbols(t); o < n.length; o++) e.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[o]) && (r[n[o]] = t[n[o]]);
          }
          return r;
        },
        s = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var i = s(r(0)),
        a = s(r(1)),
        l = r(24);
      e.default = function (t) {
        var e,
          r = t.actionItem,
          s = void 0 !== r && r,
          c = t.navIcon,
          p = void 0 !== c && c,
          u = t.className,
          d = t.children,
          f = o(t, ["actionItem", "navIcon", "className", "children"]);
        return i.default.cloneElement(d, n({}, f, {
          className: a.default(u, d.props.className, (e = {}, e[l.cssClasses.ACTION_ITEM] = s, e[l.cssClasses.NAV_ICON] = p, e))
        }));
      };
    },
    143: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, "MDCFixedTopAppBarFoundation", function () {
        return s;
      });
      var n = r(12),
        o = r(7),
        s = function (t) {
          function e(e) {
            var r = t.call(this, e) || this;
            return r.wasScrolled_ = !1, r.scrollHandler_ = function () {
              return r.fixedScrollHandler_();
            }, r;
          }
          return n.b(e, t), e.prototype.fixedScrollHandler_ = function () {
            this.adapter_.getViewportScrollY() <= 0 ? this.wasScrolled_ && (this.adapter_.removeClass(o.a.FIXED_SCROLLED_CLASS), this.wasScrolled_ = !1) : this.wasScrolled_ || (this.adapter_.addClass(o.a.FIXED_SCROLLED_CLASS), this.wasScrolled_ = !0);
          }, e;
        }(r(39).MDCTopAppBarFoundation);
      e.default = s;
    },
    144: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, "MDCShortTopAppBarFoundation", function () {
        return s;
      });
      var n = r(12),
        o = r(7),
        s = function (t) {
          function e(e) {
            var r = t.call(this, e) || this;
            return r.isCollapsed_ = !1, r;
          }
          return n.b(e, t), Object.defineProperty(e.prototype, "isCollapsed", {
            get: function get() {
              return this.isCollapsed_;
            },
            enumerable: !0,
            configurable: !0
          }), e.prototype.init = function () {
            var e = this;
            t.prototype.init.call(this), this.adapter_.getTotalActionItems() > 0 && this.adapter_.addClass(o.a.SHORT_HAS_ACTION_ITEM_CLASS), this.adapter_.hasClass(o.a.SHORT_COLLAPSED_CLASS) || (this.scrollHandler_ = function () {
              return e.shortAppBarScrollHandler_();
            }, this.adapter_.registerScrollHandler(this.scrollHandler_), this.shortAppBarScrollHandler_());
          }, e.prototype.destroy = function () {
            t.prototype.destroy.call(this);
          }, e.prototype.shortAppBarScrollHandler_ = function () {
            this.adapter_.getViewportScrollY() <= 0 ? this.isCollapsed_ && (this.adapter_.removeClass(o.a.SHORT_COLLAPSED_CLASS), this.isCollapsed_ = !1) : this.isCollapsed_ || (this.adapter_.addClass(o.a.SHORT_COLLAPSED_CLASS), this.isCollapsed_ = !0);
          }, e;
        }(r(30).a);
      e.default = s;
    },
    24: function _(t, e, r) {
      "use strict";

      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var n = "mdc-top-app-bar",
        o = n + "__section",
        s = {
          BASE: n,
          ROW: n + "__row",
          SECTION: o,
          SECTION_START: o + "--align-start",
          SECTION_END: o + "--align-end",
          FIXED: n + "--fixed",
          SHORT: n + "--short",
          SHORT_COLLAPSED: n + "--short-collapsed",
          PROMINENT: n + "--prominent",
          DENSE: n + "--dense",
          TITLE: n + "__title",
          ACTION_ITEM: n + "__action-item",
          NAV_ICON: n + "__navigation-icon"
        };
      e.cssClasses = s;
    },
    30: function _(t, e, r) {
      "use strict";

      var n = r(12),
        o = function () {
          function t(t) {
            void 0 === t && (t = {}), this.adapter_ = t;
          }
          return Object.defineProperty(t, "cssClasses", {
            get: function get() {
              return {};
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t, "strings", {
            get: function get() {
              return {};
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t, "numbers", {
            get: function get() {
              return {};
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t, "defaultAdapter", {
            get: function get() {
              return {};
            },
            enumerable: !0,
            configurable: !0
          }), t.prototype.init = function () {}, t.prototype.destroy = function () {}, t;
        }(),
        s = r(7);
      /**
       * @license
       * Copyright 2016 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */
      r.d(e, "a", function () {
        return i;
      });
      /**
       * @license
       * Copyright 2018 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */
      var i = function (t) {
        function e(r) {
          var o = t.call(this, n.a({}, e.defaultAdapter, r)) || this;
          return o.navClickHandler_ = function () {
            return o.adapter_.notifyNavigationIconClicked();
          }, o;
        }
        return n.b(e, t), Object.defineProperty(e, "strings", {
          get: function get() {
            return s.c;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e, "cssClasses", {
          get: function get() {
            return s.a;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e, "numbers", {
          get: function get() {
            return s.b;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e, "defaultAdapter", {
          get: function get() {
            return {
              addClass: function addClass() {},
              removeClass: function removeClass() {},
              hasClass: function hasClass() {
                return !1;
              },
              setStyle: function setStyle() {},
              getTopAppBarHeight: function getTopAppBarHeight() {
                return 0;
              },
              registerNavigationIconInteractionHandler: function registerNavigationIconInteractionHandler() {},
              deregisterNavigationIconInteractionHandler: function deregisterNavigationIconInteractionHandler() {},
              notifyNavigationIconClicked: function notifyNavigationIconClicked() {},
              registerScrollHandler: function registerScrollHandler() {},
              deregisterScrollHandler: function deregisterScrollHandler() {},
              registerResizeHandler: function registerResizeHandler() {},
              deregisterResizeHandler: function deregisterResizeHandler() {},
              getViewportScrollY: function getViewportScrollY() {
                return 0;
              },
              getTotalActionItems: function getTotalActionItems() {
                return 0;
              }
            };
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.init = function () {
          this.initScrollHandler(), this.initResizeHandler_(), this.adapter_.registerNavigationIconInteractionHandler("click", this.navClickHandler_);
        }, e.prototype.destroy = function () {
          this.destroyScrollHandler(), this.destroyResizeHandler_(), this.adapter_.deregisterNavigationIconInteractionHandler("click", this.navClickHandler_);
        }, e.prototype.initScrollHandler = function () {
          this.scrollHandler_ && this.adapter_.registerScrollHandler(this.scrollHandler_);
        }, e.prototype.destroyScrollHandler = function () {
          this.scrollHandler_ && this.adapter_.deregisterScrollHandler(this.scrollHandler_);
        }, e.prototype.initResizeHandler_ = function () {
          this.resizeHandler_ && this.adapter_.registerResizeHandler(this.resizeHandler_);
        }, e.prototype.destroyResizeHandler_ = function () {
          this.resizeHandler_ && this.adapter_.deregisterResizeHandler(this.resizeHandler_);
        }, e;
      }(o);
    },
    39: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, "MDCTopAppBarFoundation", function () {
        return a;
      });
      var n = r(12),
        o = r(7),
        s = r(30),
        i = 0,
        a = function (t) {
          function e(e) {
            var r = t.call(this, e) || this;
            return r.wasDocked_ = !0, r.isDockedShowing_ = !0, r.currentAppBarOffsetTop_ = 0, r.isCurrentlyBeingResized_ = !1, r.resizeThrottleId_ = i, r.resizeDebounceId_ = i, r.lastScrollPosition_ = r.adapter_.getViewportScrollY(), r.topAppBarHeight_ = r.adapter_.getTopAppBarHeight(), r.scrollHandler_ = function () {
              return r.topAppBarScrollHandler_();
            }, r.resizeHandler_ = function () {
              return r.topAppBarResizeHandler_();
            }, r;
          }
          return n.b(e, t), e.prototype.destroy = function () {
            t.prototype.destroy.call(this), this.adapter_.setStyle("top", "");
          }, e.prototype.checkForUpdate_ = function () {
            var t = -this.topAppBarHeight_,
              e = this.currentAppBarOffsetTop_ < 0,
              r = this.currentAppBarOffsetTop_ > t,
              n = e && r;
            if (n) this.wasDocked_ = !1;else {
              if (!this.wasDocked_) return this.wasDocked_ = !0, !0;
              if (this.isDockedShowing_ !== r) return this.isDockedShowing_ = r, !0;
            }
            return n;
          }, e.prototype.moveTopAppBar_ = function () {
            if (this.checkForUpdate_()) {
              var t = this.currentAppBarOffsetTop_;
              Math.abs(t) >= this.topAppBarHeight_ && (t = -o.b.MAX_TOP_APP_BAR_HEIGHT), this.adapter_.setStyle("top", t + "px");
            }
          }, e.prototype.topAppBarScrollHandler_ = function () {
            var t = Math.max(this.adapter_.getViewportScrollY(), 0),
              e = t - this.lastScrollPosition_;
            this.lastScrollPosition_ = t, this.isCurrentlyBeingResized_ || (this.currentAppBarOffsetTop_ -= e, this.currentAppBarOffsetTop_ > 0 ? this.currentAppBarOffsetTop_ = 0 : Math.abs(this.currentAppBarOffsetTop_) > this.topAppBarHeight_ && (this.currentAppBarOffsetTop_ = -this.topAppBarHeight_), this.moveTopAppBar_());
          }, e.prototype.topAppBarResizeHandler_ = function () {
            var t = this;
            this.resizeThrottleId_ || (this.resizeThrottleId_ = setTimeout(function () {
              t.resizeThrottleId_ = i, t.throttledResizeHandler_();
            }, o.b.DEBOUNCE_THROTTLE_RESIZE_TIME_MS)), this.isCurrentlyBeingResized_ = !0, this.resizeDebounceId_ && clearTimeout(this.resizeDebounceId_), this.resizeDebounceId_ = setTimeout(function () {
              t.topAppBarScrollHandler_(), t.isCurrentlyBeingResized_ = !1, t.resizeDebounceId_ = i;
            }, o.b.DEBOUNCE_THROTTLE_RESIZE_TIME_MS);
          }, e.prototype.throttledResizeHandler_ = function () {
            var t = this.adapter_.getTopAppBarHeight();
            this.topAppBarHeight_ !== t && (this.wasDocked_ = !1, this.currentAppBarOffsetTop_ -= this.topAppBarHeight_ - t, this.topAppBarHeight_ = t), this.topAppBarScrollHandler_();
          }, e;
        }(s.a);
      e.default = a;
    },
    7: function _(t, e, r) {
      "use strict";

      r.d(e, "a", function () {
        return n;
      }), r.d(e, "b", function () {
        return o;
      }), r.d(e, "c", function () {
        return s;
      });
      /**
       * @license
       * Copyright 2018 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */
      var n = {
          FIXED_CLASS: "mdc-top-app-bar--fixed",
          FIXED_SCROLLED_CLASS: "mdc-top-app-bar--fixed-scrolled",
          SHORT_CLASS: "mdc-top-app-bar--short",
          SHORT_COLLAPSED_CLASS: "mdc-top-app-bar--short-collapsed",
          SHORT_HAS_ACTION_ITEM_CLASS: "mdc-top-app-bar--short-has-action-item"
        },
        o = {
          DEBOUNCE_THROTTLE_RESIZE_TIME_MS: 100,
          MAX_TOP_APP_BAR_HEIGHT: 128
        },
        s = {
          ACTION_ITEM_SELECTOR: ".mdc-top-app-bar__action-item",
          NAVIGATION_EVENT: "MDCTopAppBar:nav",
          NAVIGATION_ICON_SELECTOR: ".mdc-top-app-bar__navigation-icon",
          ROOT_SELECTOR: ".mdc-top-app-bar",
          TITLE_SELECTOR: ".mdc-top-app-bar__title"
        };
    }
  });
});